export default {
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m),
  error: () => import("/opt/build/repo/layouts/error.vue").then(m => m.default || m)
}